// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "breadcrumb-HBbnd";
export { _1 as "__esModule", _2 as "breadcrumb" }
export default { "__esModule": _1, "breadcrumb": _2 }
